<template>
  <div>
    <!-- ===== 01 顶部品牌定位区 ===== 青花瓷渐变+蓝白背景 -->
    <section class="gradient-light text-[#0E1F52] border-b border-divider">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
            <div class="max-w-3xl">
                <h1 class="h1-title text-[#0E1F52] mb-4">联系我们-北京古杉数据-更多客户选择的审计软件、数字化人才培养伙伴</h1>
                <p class="subtitle text-[#2B2F3A]/80 mb-8">
                    专注数字化转型、数据治理、审计风控合规、AI及大模型及数字化培训（AI&数据）
                </p>
                <!-- 关键词云（SEO强化） -->
                <div class="rc-keyword-cloud">
                    <span class="rc-keyword-tag highlight">内部审计</span>
                    <span class="rc-keyword-tag">风险管理</span>
                    <span class="rc-keyword-tag">数智审计</span>
                    <span class="rc-keyword-tag">风险预警系统</span>
                    <span class="rc-keyword-tag">内部审计系统</span>
                    <span class="rc-keyword-tag">审计管理平台</span>
                    <span class="rc-keyword-tag">集团审计系统</span>
                    <span class="rc-keyword-tag">穿透式风险</span>
                    <span class="rc-keyword-tag">反舞弊系统</span>
                    <span class="rc-keyword-tag">AI智能体</span>
                </div>
                <div class="flex flex-wrap gap-4">
                    <a href="#contact1" class="px-8 py-4 bg-brand black rounded-lg text-base font-semibold shadow-lg hover:bg-[#0E1F52] transition">预约专家咨询</a>
                    <a href="#" class="px-8 py-4 bg-transparent text-brand border-2 border-brand/50 rounded-lg text-base font-semibold hover:bg-brand/5 transition">下载公司介绍</a>
                </div>
            </div>
        </div>
    </section>
    
    <!-- 固定导航 -->
    <div class="nav-fixed">
      <div class="nav-container">
        <div class="nav-menu">
          <a
            v-for="item in navItems"
            :key="item.id"
            :href="'#' + item.id"
            class="nav-item"
            :class="{ active: activeSection === item.id }"
            @click.prevent="scrollToSection(item.id)"
          >
            {{ item.label }}
          </a>
        </div>
      </div>
    </div>

    <!-- 主内容区域 -->
    <div class="main-content container">
      <!-- 关于我们 (H1) -->
      <section id="about" class="section" ref="about">
        <h1>关于古杉数据</h1>
        <p style="font-size: 18px; max-width: 1200px">
            北京古杉数据科技有限公司(以下简称古杉数据)成立于2017年，现有注册资金500万，国内领先的数字化技术解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。   <br> 公司提供主要核心业务:数字化转型咨询规划、数据管理体系咨询建设、审计风控合规产品、AI及大模型领域数据应用，数字化及 AI领域的教育培训业务。公司服务主要客户:头部央企国企及中大型企业，目标为能源电力、高端制造业等领域的头部客户。<br>当前服务过的客户包括但不限于国家电网、中国石化、中国电建、福田戴姆勒、浪潮信息、五大发电集团、戴姆勒奔驰等。公司资质及荣誉: 国家高新技术企业、北京市科技型中小企业，拥有数据及AI领域相关发明专利、多个著作，参与信通院、能源局多项审计侧数据标准制定。
        </p>

        <div class="stats-grid">
          <div
            v-for="(stat, index) in stats"
            :key="index"
            class="stat-card"
            ref="statCards"
          >
            <div class="stat-number" :ref="'stat' + index">
              {{ stat.displayValue }}
            </div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>

        <div
          style="
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 40px;
            margin-top: 40px;
          "
        >
          <div
            style="
              background: #EAF0FB;
              border-radius: 24px;
              padding: 32px;
            "
          >
            <h3>企业愿景</h3>
            <p>
              成为数据智能时代最值得信赖的企业级合作伙伴，赋能每一家组织成为数据驱动型组织。
            </p>
            <h3 style="margin-top: 24px">核心价值观</h3>
            <p>专业 · 务实 · 创新 · 共赢</p>
          </div>
          <div
            style="
              background: #EAF0FB;
              border-radius: 24px;
              padding: 32px;
            "
          >
            <h3>战略方向</h3>
            <p>1.数据治理：数据管理、数据治理、数据分析与价值、主数据管理;</p>
            <p>2.审计风控合规：审计数字化、风险管理、智能数据管理、AI审计；</p>
            <p>3.AI及大模型应用：智能数据分析、行业大模型、AI数据治理；</p>
            <p>4.数字化转型：数字化转型咨询、数字化规划、IT规划</p>
            <p>5.数字化工程师培训：工信部联合数字化工程师培训、企业内训、公开课、首席数据官CDO（实践班）培训、数据分析与治理培训</p>
          </div>
        </div>
      </section>

      <!-- 大事记 -->
      <section id="timeline" class="section">
        <h2>大事记</h2>
        <div class="timeline">
          <div
            v-for="(item, index) in timelineItems"
            :key="index"
            class="timeline-item"
          >
            <div class="timeline-year">{{ item.year }}</div>
            <div
              v-for="(monthItem, monthIndex) in item.months"
              :key="monthIndex"
            >
              <div class="timeline-month">{{ monthItem.month }}</div>
              <div class="timeline-desc">{{ monthItem.desc }}</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 权威资质 -->
      <section id="certificate" class="section">
        <h2>权威资质</h2>
        <div class="card-grid">
          <div
            v-for="(cert, index) in certificates"
            :key="index"
            class="cert-card"
          >
            <i :class="cert.icon" class="cert-icon"></i>
            <div class="cert-title">{{ cert.title }}</div>
            <div class="cert-org">{{ cert.org }}</div>
          </div>
        </div>
      </section>

      <!-- 入选报告 -->
      <section id="reports" class="section">
        <h2>入选报告</h2>
        <div class="card-grid">
          <div
            v-for="(report, index) in reports"
            :key="index"
            class="report-card"
          >
            <h3>{{ report.title }}</h3>
            <p style="color: #1f3f8f; margin: 8px 0">
              发布机构：{{ report.org }}
            </p>
            <p style="font-size: 14px; color: #5f6a7d">
              摘要：{{ report.summary }}
            </p>
            <a href="#" style="color: #1F3F8F"
              >下载报告 <i class="fas fa-download"></i
            ></a>
          </div>
        </div>
      </section>

      <!-- 品牌荣誉 -->
      <section id="honors" class="section">
        <h2>品牌荣誉</h2>
        <div class="logo-wall">
          <span
            v-for="(honor, index) in honors"
            :key="index"
            class="logo-item"
            >{{ honor }}</span
          >
        </div>
      </section>

      <!-- 最新动态 -->
      <section id="news" class="section">
        <h2>最新动态</h2>
        <div class="card-grid">
          <div v-for="(news, index) in newsItems" :key="index" class="news-card">
            <span style="color: #1f3f8f; font-size: 14px">{{ news.date }}</span>
            <h3>{{ news.title }}</h3>
            <p style="font-size: 15px">{{ news.summary }}</p>
            <a href="#" style="color: #1F3F8F"
              >阅读更多 <i class="fas fa-arrow-right"></i
            ></a>
          </div>
        </div>
      </section>

      <!-- 媒体报道 -->
      <section id="media" class="section">
        <h2>媒体报道</h2>
        <div class="card-grid">
          <div
            v-for="(media, index) in mediaItems"
            :key="index"
            class="media-card"
          >
            <i
              :class="media.icon"
              style="font-size: 30px; color: #1F3F8F; margin-bottom: 10px"
            ></i>
            <h3>{{ media.title }}</h3>
            <p style="font-size: 14px">{{ media.summary }}</p>
            <a href="#" style="color: #1F3F8F">查看报道</a>
          </div>
        </div>
      </section>

      <!-- 联系我们 -->
      <section id="contact" class="section">
        <h2>联系我们</h2>
        <div class="contact-grid">
          <div>
            <div class="info-item">
              <div class="info-icon"><i class="fas fa-map-pin"></i></div>
              <div>北京市朝阳区建国门外大街8号IFC大厦20层</div>
            </div>
            <div class="info-item">
              <div class="info-icon"><i class="fas fa-phone-alt"></i></div>
              <div>010-5678 1234</div>
            </div>
            <div class="info-item">
              <div class="info-icon"><i class="fas fa-envelope"></i></div>
              <div>contact@gushandata.com</div>
            </div>
            <div class="qr-section">
              <h4 style="margin-bottom: 12px; color: #0E1F52; font-size: 16px;">扫码添加顾问微信</h4>
              <div class="qr-row">
                <div class="qr-box">
                  <img :src="qr1" alt="顾问微信二维码" class="qr-img" />
                  <p class="qr-label">顾问微信：Shujujuece</p>
                </div>
                <div class="qr-box">
                  <img :src="qr2" alt="顾问微信二维码" class="qr-img" />
                  <p class="qr-label">顾问微信：Cchenn</p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <input type="text" placeholder="姓名 *" v-model="form.name" />
              </div>
              <div class="form-group">
                <input
                  type="text"
                  placeholder="公司名称"
                  v-model="form.company"
                />
              </div>
              <div class="form-group">
                <input type="text" placeholder="职位" v-model="form.position" />
              </div>
              <div class="form-group">
                <input
                  type="tel"
                  placeholder="联系方式 *"
                  v-model="form.contact"
                />
              </div>
              <div class="form-group">
                <textarea
                  rows="3"
                  placeholder="留言内容"
                  v-model="form.message"
                ></textarea>
              </div>
              <button class="btn-primary">立即咨询</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
      qr1: require('@/assets/img/qr_gu.jpg'),
      qr2: require('@/assets/img/qr_sang.jpg'),
      // 导航项
      navItems: [
        { id: "about", label: "关于我们" },
        { id: "timeline", label: "大事记" },
        { id: "certificate", label: "权威资质" },
        { id: "reports", label: "入选报告" },
        { id: "honors", label: "品牌荣誉" },
        { id: "news", label: "最新动态" },
        { id: "media", label: "媒体报道" },
        { id: "contact", label: "联系我们" },
      ],
      activeSection: "about",
      // 统计数据
      stats: [
        { value: 260, label: "服务客户", displayValue: "0+" },
        { value: 18, label: "行业覆盖", displayValue: "0+" },
        { value: 45, label: "顾问团队", displayValue: "0+" },
        { value: 12, label: "服务年限", displayValue: "0+" },
      ],
      // 大事记数据
      timelineItems: [
        {
          year: "2025",
          months: [
          { month: "10月，强化AI及LLM领域产品研发" }, 
          { month: "6月，建立与工信部、清华大学、东北大学等学术机构产学研合作"},    
          { month: "1月，启动数字教育培训业务(CDO、数据资产入表、人工智能及其它)"}
        ],
          
        },
        {
          year: "2024",
          months: [
            { month: "12月，获得国家高新技术企业认证" },
            { month: "11月，启动与工信部首席数据官(CDO)培训合作" },
            { month: "4月，推动与太极、慧点、百度、华为等公司合作" },

          ],
        },
        {
          year: "2023",
          months: [
            { month: "11月 获得首个发明专利,多项软著"},
            { month: "5月，参与中国电建、浪潮信息等头部企业数据管理体系建设" },
            { month: "3月，深化与网易数帆、和顺合作，形成伙伴关系" },
          ],
        },

        {
          year: "2022",
          months: [
            { month: "5月，获得北京市科技型中小企业称号"},
            { month: "8月，成立成都咨询交付中心" },
            { month: "10月，启动数据管理体系咨询业务，参与中国电建数据治理体系建设项目、戴姆勒数字化工厂项目" },
          ],
        },

        {
          year: "2021",
          months: [
            { month: "9月，聚焦央国企数字化转型"},
            { month: "11月，参与国家电网、电科院、地市供电公司项目" },
            { month: "12月，形成审计风控合规核心产品线" },
          ],
        },

        {
          year: "2020",
          months: [
            { month: "9月，参与国网甘肃项目建设\n组建西部研发团队\n"},
            { month: "11月，孵化非现场数字化管理舱、智能评价等系统" }
          ],
        },

        {
          year: "2019",
          months: [
            { month: "4月，参与中国石化大数据咨询规划，确定央企国企的数字化转型，大数据应有领域。"},
          ],
        },

        {
          year: "2017",
          months: [
            { month: "11月，运营北京古杉公司\n启动大数据平台和分析项目\n"}
          ],
        },
      ],

      // 权威资质
      certificates: [
        {
          icon: "fas fa-certificate",
          title: "ISO27001信息安全管理体系",
          org: "国际认证",
        },
        {
          icon: "fas fa-certificate",
          title: "ISO9001质量管理体系",
          org: "国际认证",
        },
        {
          icon: "fas fa-award",
          title: "国家高新技术企业",
          org: "科技部",
        },
        {
          icon: "fas fa-database",
          title: "数据管理能力成熟度（DCMM）咨询机构",
          org: "中国电子信息行业联合会",
        },
        {
          icon: "fas fa-chart-line",
          title: "工信部电子标准院 培训合作伙伴",
          org: "工信部",
        },
        {
          icon: "fas fa-globe",
          title: "DAMA中国 金牌会员",
          org: "国际数据管理协会",
        },
      ],
      // 入选报告
      reports: [
        {
          title: "数据要素市场发展报告（2024）",
          org: "中国信通院",
          summary: "古杉数据作为数据治理典型服务商入选“数据要素流通”案例章节。",
        },
        {
          title: "中国AI大模型企业应用白皮书",
          org: "中国人工智能学会",
          summary: '古杉数据"金融大模型合规应用"入选最佳实践案例。',
        },
        {
          title: "数据资产管理实践指南（2025）",
          org: "中国电子技术标准化研究院",
          summary: "联合编写单位，提供数据资产盘点方法论。",
        },
      ],
      // 品牌荣誉
      honors: [
        "年度数据治理优秀服务商",
        "AI应用创新50强",
        "工信部人才工程合作单位",
        "国家高新技术企业",
        "北京市创新型中小企业",
        "CDMP|CDGA|CDGP培训机构",
        "高潜细分领域小巨头",
        "DAMA 国际金牌会员",
      ],
      // 最新动态
      newsItems: [
        {
          date: "2025.03.12",
          title: "古杉数据与上海国家会计学院达成战略合作",
          summary: "双方将共同开发财务数字化与数据治理系列课程，培养复合型数据人才。",
        },
        
        {
          date: "2025.02.20",
          title: "首席数据官(CDO)实践班春季招生启动",
          summary: "联合工信部电子标准院，培养数据战略领导者，3月北京开班。",
        },

        {
          date: "2025.01.08",
          title: '古杉数据入选中国信通院"数据治理产业图谱"',
          summary: "在数据治理服务、数据咨询两个领域同时入选。",
        },

      ],
      // 媒体报道
      mediaItems: [
        {
          icon: "fas fa-newspaper",
          title: "36氪专访：古杉数据谈企业级AI应用落地",
          summary: "“大模型不是终点，与业务流程结合才是价值所在”",
        },
        {
          icon: "fas fa-tower-broadcast",
          title: "第一财经：数据资产入表元年，咨询机构如何赋能？",
          summary: "古杉数据提出“治理-估值-入表”三步法",
        },
        {
          icon: "fas fa-tv",
          title: "中国信息化周报：数据治理人才培养新范式",
          summary: "专访古杉数据培训中心，解读CDO课程体系",
        },
      ],
      // 表单数据
      form: {
        name: "",
        company: "",
        position: "",
        contact: "",
        message: "",
      },
    };
  },
  mounted() {
    this.initScrollListener();
    this.animateNumbers();
    // 处理URL锚点
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      this.$nextTick(() => this.scrollToSection(id));
    }
  },
  watch: {
    '$route.hash'(hash) {
      if (hash) {
        const id = hash.substring(1);
        this.$nextTick(() => this.scrollToSection(id));
      }
    }
  },
  methods: {
    // 滚动到指定Section
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset - 60;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    },

    // 初始化滚动监听
    initScrollListener() {
      window.addEventListener("scroll", () => {
        requestAnimationFrame(this.updateActiveSection);
      });
    },

    // 更新当前激活的Section
    updateActiveSection() {
      const sections = document.querySelectorAll(".section");
      const scrollPos = window.pageYOffset + 100;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 70;
        const sectionBottom = sectionTop + section.offsetHeight;

        if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
          this.activeSection = section.getAttribute("id");
        }
      });
    },

    // 数字滚动动画
    animateNumbers() {
      const animateNumber = (element, target) => {
        let current = 0;
        const increment = target / 80;
        const timer = setInterval(() => {
          current += increment;
          if (current >= target) {
            element.innerText = target + "+";
            clearInterval(timer);
          } else {
            element.innerText = Math.floor(current) + "+";
          }
        }, 16);
      };

      // 等待DOM更新完成
      this.$nextTick(() => {
        this.stats.forEach((stat, index) => {
          const refName = "stat" + index;
          const elements = this.$refs[refName];
          if (elements && elements[0]) {
            animateNumber(elements[0], stat.value);
          }
        });
      });
    },

    // 表单提交
    handleSubmit() {
      alert("表单已提交，我们会尽快联系您。");
      // 重置表单
      this.form = {
        name: "",
        company: "",
        position: "",
        contact: "",
        message: "",
      };
    },
  },
};
</script>

<style scoped>

:root {
  --primary-blue: #1f3f8f;
  --deep-indigo: #0e1f52;
  --light-porcelain: #eaf0fb;
  --bg-light: #f5f7fa;
  --text-dark: #2b2f3a;
  --card-shadow: 0 12px 28px rgba(0, 10, 30, 0.04),
    0 4px 16px rgba(31, 63, 143, 0.08);
  --border-light: #e9edf4;
  --nav-height: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 青花瓷渐变背景（淡蓝+白） */
.gradient-light {
  background: linear-gradient(135deg, var(--porcelain-blue) 0%, #FFFFFF 100%);
}

/* 青花瓷纹理背景（极浅） */
.bg-porcelain-pattern {
  background-color: var(--porcelain-blue);
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 5 L55 30 L30 55 L5 30 Z' fill='none' stroke='%231F3F8F' stroke-width='0.5' opacity='0.1' /%3E%3C/svg%3E");
}

/* 固定导航 */
.nav-fixed {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  z-index: 1000;
  border-bottom: 1px solid rgba(31, 63, 143, 0.1);
  height: var(--nav-height);
  backdrop-filter: blur(8px);
  background: rgba(255, 255, 255, 0.9);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 24px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;


}

.nav-menu {
  display: flex;
  gap: 8px;
  background-color: #f5f7fa;
  padding: 4px;
  border-radius: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

.nav-item {
  padding: 8px 20px;
  font-size: 16px;
  font-weight: 500;
  color: #2b2f3a;
  border-radius: 32px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  display: inline-block;
  background-color: transparent;
  border: none;
}

.nav-item:hover {
  background-color: #eaf0fb;
  color: #1f3f8f;
}

.nav-item.active {
  background-color: #1f3f8f;
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(31, 63, 143, 0.2);
}

/* 主内容区 */
.main-content {
  padding-top: 40px;
}

.section {
  margin-bottom: 100px;
  scroll-margin-top: calc(var(--nav-height) + 20px);
  opacity: 0;
  transform: translateY(15px);
  animation: sectionFadeIn 0.5s ease-in-out forwards;
}

@keyframes sectionFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

h1 {
  font-size: 42px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 24px;
  letter-spacing: -0.02em;
}

h2 {
  font-size: 28px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 40px;
  letter-spacing: -0.01em;
  position: relative;
  display: inline-block;
}

h2:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: #1F3F8F;
  border-radius: 4px;
}



h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #0E1F52;
}

/* 统计卡片 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin: 40px 0;
}

.stat-card {
  background: #f5f7fa;
  border-radius: 16px;
  padding: 28px 20px;
  text-align: center;
  transition: all 0.3s;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);
}

.stat-number {
  font-size: 42px;
  font-weight: 700;
  color: #1F3F8F;
  line-height: 1.2;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 16px;
  color: #0f2a2a;
}

/* 时间轴 */
.timeline {
  position: relative;
  padding-left: 40px;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background: linear-gradient(
    to bottom,
    #1F3F8F,
    #EAF0FB
  );
  border-radius: 2px;
}

.timeline-item {
  position: relative;
  margin-bottom: 36px;
  padding-left: 30px;
  transition: transform 0.3s ease;
}

.timeline-item:hover {
  transform: scale(1.02) translateX(6px);
}

.timeline-year {
  font-size: 24px;
  font-weight: 700;
  color: #1F3F8F;
  margin-bottom: 8px;
  position: relative;
}

.timeline-year::before {
  content: "";
  position: absolute;
  left: -36px;
  top: 12px;
  width: 12px;
  height: 12px;
  background: #1F3F8F;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 0 0 2px rgba(31, 63, 143, 0.2);
}

.timeline-month {
  font-size: 16px;
  font-weight: 500;
  color: #0f2a2a;
  margin-bottom: 6px;
  position: relative;
}

.timeline-month::before {
  content: "";
  position: absolute;
  left: -34px;
  top: 8px;
  width: 8px;
  height: 8px;
  background: #EAF0FB;
  border-radius: 50%;
  border: 2px solid #1F3F8F;
}

.timeline-desc {
  font-size: 15px;
  color: #5a5f6b;
}

/* 卡片网格 */
.card-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

/* 证书/报告卡片网格 */
.card-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
}

.cert-card, .report-card, .honor-card, .news-card, .media-card {
    background: white;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 12px 28px rgba(0, 10, 30, 0.04);
    transition: all 0.3s ease;
    border: 1px solid rgba(31,63,143,0.05);
}

.cert-card:hover, .report-card:hover, .honor-card:hover, .news-card:hover, .media-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}

.cert-icon {
    font-size: 40px;
    color: #2A7DE1;
    margin-bottom: 16px;
}
.cert-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
}
.cert-org {
    color: #5f6a7d;
    font-size: 14px;
}



.media-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 12px 28px rgba(0, 10, 30, 0.04);
  transition: all 0.3s ease;
  border: 1px solid rgba(31, 63, 143, 0.05);
}

.media-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(31, 63, 143, 0.12);
}

.cert-icon {
  font-size: 40px;
  color: #1F3F8F;
  margin-bottom: 16px;
}

.cert-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.cert-org {
  color: #5f6a7d;
  font-size: 14px;
}

/* 荣誉Logo墙 */
.logo-wall {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: space-between;
  align-items: center;
  background: #f5f7fa;
  padding: 40px;
  border-radius: 32px;
}

.logo-item {
  font-size: 18px;
  font-weight: 500;
  color: #0E1F52;
  background: white;
  padding: 14px 28px;
  border-radius: 60px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  transition: all 0.3s;
  border: 1px solid rgba(31, 63, 143, 0.1);
}

.logo-item:hover {
  transform: scale(1.05);
  background: #1F3F8F;
  color: white;
}


/* 联系我们 */
.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  background: #f5f7fa;
  border-radius: 32px;
  padding: 20px;
}



.info-item {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.info-icon {
  width: 48px;
  height: 48px;
  background: #EAF0FB;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1F3F8F;
  font-size: 20px;
}

.form-group {
  margin-bottom: 6px;
}

input,
textarea,
select {
  width: 100%;
  padding: 14px 18px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  font-size: 16px;
  transition: 0.2s;
  font-family: inherit;
}

input:focus,

textarea:focus {
  border-color: #1F3F8F;
  outline: none;
  box-shadow: 0 0 0 3px rgba(31, 63, 143, 0.15);
}

.btn-primary {
  background: #1F3F8F;
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
  width: 100%;
}

.btn-primary:hover {
  background: #0e3170;
}

/* 地图占位 → 顾问二维码 */
.qr-section {
  margin-top: 24px;
}
.qr-row {
  display: flex;
  gap: 24px;
}
.qr-box {
  text-align: center;
}
.qr-img {
  width: 140px;
  height: 140px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid #e9edf4;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}
.qr-label {
  font-size: 12px;
  color: #8a95a8;
  margin-top: 8px;
}


/* 关键词标签云 */
.rc-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.rc-keyword-tag {   
  background: white;
  color: var(--rc-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.rc-keyword-tag.highlight {
  background: #D4AF37;
  color: #1e3c3c;
}


/* 响应式 */
@media (max-width: 992px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .contact-grid {
    grid-template-columns: 1fr;
  }
  .nav-menu {
    flex-wrap: wrap;
    height: auto;
    padding: 8px;
  }
}

@media (max-width: 640px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  .card-grid {
    grid-template-columns: 1fr;
  }
  .logo-wall {
    gap: 20px;
  }
}


</style>